export const sharedStyle = {
  pageMaxWidth: "8xl",
};
